import * as axios from 'axios';
import _ from 'lodash';

import { buildQuery } from '../../common/utils.js';

export async function getEstimatedEmployee(locationId, variations = []) {
  const query = buildQuery({
    location_id: locationId,
    kiosk_only: true,
    variation_ids:
      !variations || !variations.length ? undefined : variations.join(','),
  });

  try {
    const res = await axios.get(`/api/mkp/v1/estimations.json?${query}`);

    const estimation = _.get(res, 'data.estimations[0].chosen_time', null);

    return { employeeId: estimation?.employee_id, estimation };
  } catch (error) {
    console.log(error);
    // eslint-disable-next-line
    Raven.captureException(error);
    return null;
  }
}

export async function getEstimationsWithEmployeeAllocations(locationId, sequenceData) {
  const queryData = {
    location_id: locationId,
    kiosk_only: true,
  };

  if (sequenceData && sequenceData.length > 0) {
    sequenceData.forEach((s, i) => {
      queryData[`sequences[${i}][employee_id]`] = s.employee_id;
      queryData[`sequences[${i}][variation_ids]`] = s.variation_ids;
      queryData[`sequences[${i}][for_employee_ids]`] = s.for_employee_ids;
      queryData[`sequences[${i}][child_id]`] = s.child_id;
      queryData[`sequences[${i}][client_id]`] = s.client_id;
    });
  }

  const query = buildQuery(queryData);

  try {
    const res = await axios.get(`/api/mkp/v1/estimations.json?${query}`);

    // default, single appt for single customer / child account
    const estimation = _.get(res, 'data.estimations[0].chosen_time', null);
    const allEstimations = _.get(res, 'data.estimations', [])

    const defaultResult = { employeeId: estimation?.employee_id, estimation };
    let resultHash = { employeeId: estimation?.employee_id, estimation };

    if (sequenceData?.length) {
      resultHash = {}
      const estimationsHashedByClientAndChild = {}

      // eslint-disable-next-line
      allEstimations?.forEach((estimation) => {
        const {
          client_id,
          child_id,
          chosen_time,
          employee_id
        } = estimation
        estimationsHashedByClientAndChild[`${client_id}_${child_id}_${employee_id}`] = {
          employeeId: chosen_time?.employee_id,
          estimation: chosen_time
        }
      })

      sequenceData.forEach((data) => {
        const { child_id = null, client_id = null, employee_id = null, for_employee_ids = [] } = data

        const estimationForChildAndClientSelection = estimationsHashedByClientAndChild[`${client_id}_${child_id}_${employee_id}`] || defaultResult
        resultHash[`${client_id}_${child_id}_${employee_id}`] = estimationForChildAndClientSelection
        
        if (for_employee_ids?.length) {
          for_employee_ids.forEach(employee_id => {
            const estimationForChildAndClientSelection = estimationsHashedByClientAndChild[`${client_id}_${child_id}_${employee_id}`] || defaultResult
            resultHash[`${client_id}_${child_id}_${employee_id}`] = estimationForChildAndClientSelection
          })
        }
      })
    }

    return {resultHash, rawData: res?.data?.estimations || []}
  } catch (error) {
    console.log(error);
    // eslint-disable-next-line
    Raven.captureException(error);
    return {resultHash: {}, rawData: []}
  }
}


export const extractRequiredResourcesBySegmentTemplates = (segmentFulFillmentmentTree = {}) => {
  const resourcesBySegmentHash = {}

  const extractResourceIdsPerSegmentTemplate = ({segment_template_id, fulfillments, children }) => {
    if (segment_template_id !== null && segment_template_id !== undefined) {
      if (!resourcesBySegmentHash[segment_template_id]) {
        resourcesBySegmentHash[segment_template_id] = []
      }

      // eslint-disable-next-line
      fulfillments?.forEach(({resource_ids, requirement_id}) => {
        if (resource_ids) {
          resource_ids.forEach((resource_id) => {
            resourcesBySegmentHash[segment_template_id].push({
              resource_id,
              requirement_id,
            })
          })
        }
      })
    }

    // eslint-disable-next-line
    children?.forEach((child) => {
      extractResourceIdsPerSegmentTemplate(child)
    })
  }

  extractResourceIdsPerSegmentTemplate(segmentFulFillmentmentTree)

  return resourcesBySegmentHash
}

export const extractDurationsBySegmentTemplates = (segmentFulFillmentmentTree = {}) => {
  const durationsBySegmentsHash = {}
  const extractResourceIdsPerSegmentTemplate = ({segment_template_id, children, time_span }) => {
    if (segment_template_id !== null && segment_template_id !== undefined) {
      if (!durationsBySegmentsHash[segment_template_id] && time_span) {
        durationsBySegmentsHash[segment_template_id] = Math.round(time_span / 60)
      }
    }

    // eslint-disable-next-line
    children?.forEach((child) => {
      extractResourceIdsPerSegmentTemplate(child)
    })
  }

  extractResourceIdsPerSegmentTemplate(segmentFulFillmentmentTree)

  return durationsBySegmentsHash
}